import React from "react"
import { Dropdown, Avatar } from "antd"
import { useNavigate } from "react-router-dom"
import { UserOutlined, LoginOutlined } from "@ant-design/icons"
import { useStore } from "../../ui"
import { convertLinkImg } from "../../../lib/function"
import { resolveAvatarUrl } from "../../../lib/avatar"

const Header = ({ user }) => {
  const { logOut } = useStore()
  const navigate = useNavigate()

  const menuItems = [
    { key: "profile", icon: <UserOutlined />, label: "Thông tin tài khoản", onClick: () => navigate("/profile") },
    { key: "logout", icon: <LoginOutlined />, label: "Đăng xuất", onClick: () => { logOut(); navigate("/login") } }
  ]

  return (
    <div className="flex">
      <Dropdown menu={{ items: menuItems }} placement="bottomLeft">
        <div className="cursor-pointer flex justify-center items-center">
          <div className="flex items-center justify-center hover-sb mr-2">
            <Avatar
              size={30}
              src={convertLinkImg(resolveAvatarUrl(user?.avatar))}
            />
          </div>
          <span className="user-name text-white ml-2">{user?.name || "User"}</span>
        </div>
      </Dropdown>
    </div>
  )
}

export default Header
